import React from 'react'

export default class IconLogoDreamhost extends React.Component {

    render() {
        let color = "#C8C5FE";
        if (this.props.color) color = this.props.color;
        let className = "icons-icon";

        return <svg className={className} style={this.props.style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_391_42723)">
                <rect width="24" height="24" rx="6" fill="white" />
                <path d="M23.4071 17.9176C21.4732 18.9832 19.2631 19.5752 16.8951 19.5358C9.86998 19.3779 4.34463 13.7342 4.46303 6.86694C4.50249 4.53839 5.2129 2.36772 6.3969 0.552246C2.64755 2.64399 0.0822112 6.5512 0.0032776 11.0899C-0.15459 17.9176 5.41023 23.6009 12.3959 23.7587C17.0529 23.8377 21.118 21.5091 23.4071 17.9176Z" fill="#071C26" />
                <path d="M13.1457 0C11.2513 0 9.4753 0.473602 7.89663 1.34187C6.90996 2.96001 6.35742 4.81495 6.27849 6.70936C6.16009 12.6688 11.0145 17.6022 17.0529 17.7206C18.8684 17.7206 20.9207 17.2865 22.4993 16.4182C23.4465 14.8001 23.9991 12.9056 23.9991 10.8928C24.078 4.89388 19.1841 0 13.1457 0Z" fill="#0073EC" />
            </g>
            <defs>
                <clipPath id="clip0_391_42723">
                    <rect width="24" height="24" rx="6" fill="white" />
                </clipPath>
            </defs>
        </svg>
    }
}    
